import { nanoid } from 'nanoid';

const getRandomUUID = () => {
    if (crypto?.randomUUID) {
        return crypto.randomUUID();
    }
    return nanoid();
};

export {
    getRandomUUID,
};
